
export const MY_STUFF_NO_PLAYLISTS = 'You have no playlists yet';
export const MY_STUFF_NO_ITEMS = 'You have no videos yet';
export const MY_STUFF_NO_ITEMS_GROUP = 'There are no items in this playlist';
export const MY_STUFF_NO_ITEMS_LANG = 'There are no videos for selected language';
export const MY_STUFF_NO_PLAYLISTS_LANG = 'You have no playlists for selected language';
